(() => {
  function initialize() {
    document.querySelectorAll('.rpl-all-wines').forEach(section => {
      if (section.dataset.availabilityReady) return;
      section.dataset.availabilityReady = 'true';
      const groups = [...section.querySelectorAll('.rpl-wine-grid')].map(grid => ({grid, cards: [...grid.querySelectorAll('.rpl-wine-card')]}));
      let busy = false;
      async function refresh() {
        if (busy || document.hidden || !section.isConnected) return;
        busy = true;
        let catalog;
        try { const response = await fetch('https://republic-events.v2apps.com/wines.json', {credentials:'omit', signal:AbortSignal.timeout(20000)}); if (!response.ok) throw Error('Wine source unavailable'); catalog = (await response.json()).products; } catch { busy = false; return; }
        await Promise.allSettled(groups.flatMap(({cards}) => cards.map(async card => {
          let badge = card.querySelector('.rpl-wine-availability');
          if (!badge) {
            badge = document.createElement('p');
            badge.className = 'rpl-wine-availability';
            card.querySelector('h3').after(badge);
          }
          try {
            const url = new URL(card.href);
            if (url.hostname !== 'conradfamilywines.com') return;
            url.pathname += '.js';
            const product = catalog[url.pathname.split('/').pop().replace(/\.js$/, '')];
            if (!product) return;
            const image = card.querySelector('.rpl-wine-photo');
            if (image && typeof product.image === 'string' && product.image) {
              const source = new URL(product.image, 'https://conradfamilywines.com');
              if (source.protocol === 'https:' && (source.hostname === 'cdn.shopify.com' || source.hostname === 'conradfamilywines.com')) {
                if (image.src !== source.href) {
                  const previous = image.src;
                  image.onerror = () => { image.onerror = null; image.src = previous; };
                  image.removeAttribute('srcset');
                  image.src = source.href;
                }
              }
            }
            const media = card.querySelector('.rpl-wine-awards');
            if (media) {
              media.querySelectorAll('.rpl-synced-medal').forEach(el => el.remove());
              (product.medals || []).forEach(medal => {
                const badgeImage = document.createElement('img');
                badgeImage.className = 'rpl-synced-medal';
                badgeImage.src = medal.src;
                const label = document.createElement('textarea');
                label.innerHTML = medal.alt;
                badgeImage.alt = label.value;
                badgeImage.loading = 'lazy';
                media.append(badgeImage);
              });
            }
            if (typeof product.available !== 'boolean') throw new Error('Unknown availability');
            card.dataset.wineAvailability = product.available ? 'available' : 'sold-out';
            const comingSoon = new Set(['/products/the-fiddler-texas-republic-cabernet-sauvignon.js', '/products/munson-texas-republic-tempranillo.js', '/products/the-treaty-texas-republic-reserve-blend.js']);
            badge.textContent = product.available ? 'Available' : (comingSoon.has(url.pathname) ? 'Coming soon' : 'Sold out');
          } catch {
            card.dataset.wineAvailability = 'unknown';
            badge.textContent = 'Check availability';
          }
        })));
        groups.forEach(({grid, cards}) => {
          const sorted = cards.slice().sort((a,b) => Number(a.dataset.wineAvailability === 'sold-out') - Number(b.dataset.wineAvailability === 'sold-out'));
          sorted.forEach((card,index) => { if (grid.children[index] !== card) grid.insertBefore(card,grid.children[index] || null); });
        });
        busy = false;
      }
      refresh();
      const timer = setInterval(() => { if (!section.isConnected) clearInterval(timer); else refresh(); }, 60000);
      document.addEventListener('visibilitychange', refresh);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
